import React from 'react';
import clone from 'clone';

import classNames from 'classnames';

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showItem: 3,
    };
    this.handleChecked = this.handleChecked.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }
  handleLoad(type, e) {
    e.preventDefault();
    this.props.onHandleShowMore(type);
  }
  handleChecked(e) {
    const values = [];
    this.options.forEach((item) => {
      if (item.key === parseInt(e.target.value, 10)) {
        item.isChecked = e.target.checked;
      }
      if (item.isChecked) values.push(item);
    });
    this.props.onSelectCheckBox(values);
  }
  render() {
    this.options = clone(this.props.options);
    this.options.map((item) => {
      if (this.props.value.indexOf(item.slug) !== -1) {
        item.isChecked = true;
      }
      this.props.previewData.map((filterItem) => {
        for (const key in filterItem.terms) {
          if (key === this.props.searchItem) {
            if (filterItem.terms[key].indexOf(item.slug) !== -1) {
              item.isEnabled = 'enabled';
            }
          }
        }
      });
      if (!item.isEnabled) {
        item.isEnabled = 'disabled';
      }
    });
    //  disabled={item.isEnabled === 'enabled' ? '' : 'disabled'}
    const singleCheckBoxItem = (item, index) => {
      return (
        <span className="single-input searchoption" key={'re-checkobx-' + index}>
          <input type="checkbox" id={item.slug + '-' + this.props.block.uid} checked={item.isChecked} value={item.key} onChange={this.handleChecked}/>
          <label className="" htmlFor={item.slug + '-' + this.props.block.uid}><span className="rq-search-text">{item.value}</span>
          {this.props.showNumberOfItems === 'true' ? <span className="pull-right rq-number-of-product" >{ item.count }</span> : ''}
          </label>
        </span>
        );
    };
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    let setColumnStyle = null;
    if (this.props.setColumn === '1') {
      setColumnStyle = 'checkbox-input-content';
    } else if (this.props.setColumn === '2') {
      setColumnStyle = 'checkbox-input-content split';
    } else if (this.props.setColumn === '3') {
      setColumnStyle = 'checkbox-input-content split-2';
    } else if (this.props.setColumn === '4') {
      setColumnStyle = 'checkbox-input-content split-3';
    }
    const options = [];
    let showItem = this.props.showItem;
    for (let key = 0; key < showItem; key++) {
      options.push(this.options[key]);
    }
    return (
      <div className={childInputClass}>
        <span className={setColumnStyle}>
          { this.options.length ? options.map(singleCheckBoxItem) : null }
        </span>
        {this.props.showLoadLessBlock === true ? <div>
          {
            this.props.showLoadMore === true ? <a className="show-less-btn" href="#" onClick={this.handleLoad.bind(this,'more')}>Show More</a> : <a className="show-less-btn" href="#" onClick={this.handleLoad.bind(this,'less')}>Show Less</a>
          }
        </div> : null}
      </div>
    );
  }
}

CheckBox.propTypes = {
  'previewData': React.PropTypes.array,
  'searchItem': React.PropTypes.string,
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'onSelectCheckBox': React.PropTypes.func,
  'isOpenElement': React.PropTypes.string,
  'showNumberOfItems': React.PropTypes.string,
  'setColumn': React.PropTypes.string,
  'block': React.PropTypes.object,
};

export default CheckBox;



// WEBPACK FOOTER //
// ./assets/src/frontend/element/checkbox.js